module.exports = __webpack_public_path__ + "static/media/Lamentation - English - translated by J_lee_77777.cfcd14c7.txt";